export const state = {
  isNew: false,
  showModal: false,
  activePayment: null,
  newPayments: [],
  contracts: []
}

export const mutations = {
  TOGGLE_PC_PROP (state, { field, value }) {
    state[field] = value
  }
}

export default {
  state,
  mutations
}
